import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { compactDecrypt } from '../jwe/compact/decrypt.js';
import jwtPayload from '../lib/jwt_claims_set.js';
import { JWTClaimValidationFailed } from '../util/errors.js';
export function jwtDecrypt(_x, _x2, _x3) {
  return _jwtDecrypt.apply(this, arguments);
}

function _jwtDecrypt() {
  _jwtDecrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(jwt, key, options) {
    var decrypted, payload, protectedHeader, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return compactDecrypt(jwt, key, options);

          case 2:
            decrypted = _context.sent;
            payload = jwtPayload(decrypted.protectedHeader, decrypted.plaintext, options);
            protectedHeader = decrypted.protectedHeader;

            if (!(protectedHeader.iss !== undefined && protectedHeader.iss !== payload.iss)) {
              _context.next = 7;
              break;
            }

            throw new JWTClaimValidationFailed('replicated "iss" claim header parameter mismatch', 'iss', 'mismatch');

          case 7:
            if (!(protectedHeader.sub !== undefined && protectedHeader.sub !== payload.sub)) {
              _context.next = 9;
              break;
            }

            throw new JWTClaimValidationFailed('replicated "sub" claim header parameter mismatch', 'sub', 'mismatch');

          case 9:
            if (!(protectedHeader.aud !== undefined && JSON.stringify(protectedHeader.aud) !== JSON.stringify(payload.aud))) {
              _context.next = 11;
              break;
            }

            throw new JWTClaimValidationFailed('replicated "aud" claim header parameter mismatch', 'aud', 'mismatch');

          case 11:
            result = {
              payload: payload,
              protectedHeader: protectedHeader
            };

            if (!(typeof key === 'function')) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", _objectSpread(_objectSpread({}, result), {}, {
              key: decrypted.key
            }));

          case 14:
            return _context.abrupt("return", result);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _jwtDecrypt.apply(this, arguments);
}